{
  "until": "{{duration}} until {{prayer}}",
  "until_at": "{{duration}} until {{prayer}} · {{time}}",
  "begin_focus": "Begin focus",
  "add_task": "Add a task",
  "more_tasks": "+{{count}} more",
  "fajr_at": "Fajr at {{time}}",
  "schedule_title": "Today",
  "plan_my_day": "Plan my day",
  "planning": "Planning…",
  "suggested": "Suggested",
  "keep_plan": "Keep plan",
  "undo_plan": "Undo",
  "plan_error": "Couldn't plan right now. Try again.",
  "plan_empty": "Nothing to plan yet — add a task first.",
  "plan_settled": "Everything is already in its place.",
  "view_list": "List",
  "view_switch_aria": "Switch between list and day view",
  "unassigned": "Unscheduled",
  "assign_title": "Prayer block",
  "no_block": "No block",
  "assign_aria": "Assign to a prayer block",
  "open_schedule_aria": "Open today's schedule",
  "collapse_aria": "Collapse",
  "focus_session_label": "{{block}} · Focus",
  "block_hero": "Deep work until {{prayer}}",
  "moments_away": "{{prayer}} is moments away",
  "block_clear": "All clear — rest until {{prayer}}",
  "alhamdulillah": "Alhamdulillah",
  "exit_hint": "Esc to leave quietly",
  "exit_hint_touch": "Tap ✕ to leave quietly",
  "mark_done_aria": "Mark task complete",
  "quick_add_placeholder": "Add to this block…",
  "focus_task_aria": "Focus on this task",
  "strip_return_aria": "Return to focus session · {{countdown}}",
  "plan_by_voice_aria": "Plan my day by voice",
  "voice_hint": "Say what's on your plate today…",
  "voice_done": "Done",
  "voice_done_aria": "Finish and plan my day",
  "voice_transcribing": "Listening back…",
  "voice_listening_aria": "Listening — describe your day",
  "new_tag": "New",
  "voice_keep_plan": "Add & keep plan",
  "plan_voice_empty": "No tasks in that — try telling me what you need to do.",
  "voice_nothing_heard": "Didn't catch that — try again."
}
